module.exports = __webpack_public_path__ + "static/media/28.06ffb398.jpeg";